import React, { useCallback, useEffect, useRef, useState } from "react";
import '../invoice.css';
import SaleReturnInvoicePage from "./SaleReturnInvoicePage";
import { Link } from "react-router-dom";


const DownloadBtnSaleReturnInvoicePdf = ({auth, loading}) => {
    const [timeLeft, setTimeLeft] = useState(5); 
    const [isActive, setIsActive] = useState(false);
    const [isClickToGeneratePDF, setIsClickToGeneratePDF] = useState(false);
    
    const triggerPDFGeneration = useCallback(() => {
        console.log("PDF Generation triggered!");
        setIsClickToGeneratePDF(true);
    }, []);
    
    useEffect(() => {
        let timer = null;
    
        if (isActive && timeLeft > 0) {
          timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
          }, 1000);
        } else if (timeLeft === 0) {
          triggerPDFGeneration();
          timer = setTimeout(() => {
            setIsActive(false);
            loading(false);
            clearInterval(timer);
          }, 1000); 
        }
    
        return () => clearInterval(timer);
      }, [isActive, timeLeft, triggerPDFGeneration]);

   
      const startCountdown = () => {
        loading(true);
        setTimeLeft(5); 
        setIsActive(true);
        setIsClickToGeneratePDF(false); 
      };
   
    return (
        <>
            {
                isActive && <SaleReturnInvoicePage auth={auth} isClickToGeneratePDF={isClickToGeneratePDF} />
            }
            <Link className="dropdown-item" style={{ textTransform: 'capitalize' }} onClick={() => {
                startCountdown();
            }}>
                Download PDF
            </Link>
        </>
    )
}
export default DownloadBtnSaleReturnInvoicePdf;